import { devToolsStatusDotVariants } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsPanel/DevToolsStatusDot/index.styles';
import type { DevToolsStatusDotProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsPanel/DevToolsStatusDot/index.types';
import React from 'react';

/**
 * DevToolsStatusDot - Traffic-light dot on a tab label
 *
 * Pulses while it is failing, so a broken connection is visible without
 * opening the tab.
 */
export const DevToolsStatusDot: React.FC<DevToolsStatusDotProps> = ({
  status,
}) => <span className={devToolsStatusDotVariants({ status })} />;
